module.exports = __webpack_public_path__ + "static/media/ap4.edb7c438.jpg";